<template>
    <div class="Maker">
        <div class="maker-title">魅控监测</div>
        <div class="content column-center">
            <div class="monitor row-center">
                <div class="parameters">
                    <div class="title">环境参数</div>
                    <div class="temperature"></div>
                    <div class="title">UPS参数</div>
                    <div class="voltage">
                        <div class="panel row-center">
                            <div class="item">
                                <div class="name">输出电压(V)</div>
                                <div class="item">
                                    <p>A<span>12.16</span></p>
                                    <p>B<span>12.16</span></p>
                                    <p>C<span>12.16</span></p>
                                </div>
                            </div>
                            <div class="item">
                                <div class="name">输出电流(A)</div>
                                <div class="item">
                                    <p>A<span>12.16</span></p>
                                    <p>B<span>12.16</span></p>
                                    <p>C<span>12.16</span></p>
                                </div>
                            </div>
                        </div>
                        <div class="panel row-center">
                            <div class="item">
                                <div class="name">输入电压(V)</div>
                                <div class="item">
                                    <p>A<span>12.16</span></p>
                                    <p>B<span>12.16</span></p>
                                    <p>C<span>12.16</span></p>
                                </div>
                            </div>
                            <div class="item">
                                <div class="name">输入电流(A)</div>
                                <div class="item">
                                    <p>A<span>12.16</span></p>
                                    <p>B<span>12.16</span></p>
                                    <p>C<span>12.16</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cabinet">
                    <div class="title">魅控智能监控柜</div>
                    <div class="surveillance">
                        <img src="../../assets/img/maker2.png" alt="">
                    </div>
                    <div class="specs row-center">
                        <div class="item">
                            <p><span class="n">柜体规格</span><span class="val">600*800*1800mm</span></p>
                            <p><span class="n">U位规格</span><span class="val">42</span></p>
                            <p><span class="n">占用率</span><span class="val">38.1 %</span></p>
                            <p><span class="n">额定功率</span><span class="val">8 kW</span></p>
                        </div>
                        <div class="item">
                            <p><span class="n">负载率</span><span class="val">24.30 ℃</span></p>
                            <p><span class="n">温度上</span><span class="val">42</span></p>
                            <p><span class="n">温度中</span><span class="val">38.1 %</span></p>
                            <p><span class="n">温度下</span><span class="val">24.30 ℃</span></p>
                        </div>
                    </div>
                </div>
                <div class="Smoke">
                    <div class="title">烟感</div>
                    <div class="info">
                        <div class="item">烟感1 <span>正常</span></div>
                        <div class="item">烟感1 <span>正常</span></div>
                    </div>
                    <div class="title">漏水</div>
                    <div class="info">
                        <div class="item">漏水 <span>正常</span></div>
                    </div>
                    <div class="title">门磁</div>
                    <div class="info">
                        <div class="item">前门 <span>断开</span></div>
                        <div class="item">后门 <span>断开</span></div>
                    </div>
                    <div class="title">照明</div>
                    <div class="info">
                        <div class="item">照明1 <span>正常</span></div>
                    </div>
                </div>
            </div>
            <div class="record">
                <div class="co-option">
                    事件记录
                    <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                    </el-date-picker>
                </div>
                <div class="table">
                    <el-table
                        :data="tableData"
                        stripe
                        style="width: 100%">
                        <el-table-column
                            prop="date"
                            label="序号"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="等级"
                            width="180">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="位置">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="事件分类">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="事件名称">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="发生时间">
                        </el-table-column>
                        <el-table-column
                            prop="address"
                            label="结束时间">
                        </el-table-column>
                    </el-table>
                    
                    <div class="paging">
                        <el-button round>首页</el-button>
                        <el-button round>上一页</el-button>
                        <span>1/10</span>
                        <el-button round>下一页</el-button>
                        <el-button round>尾页</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    data() {
      return {
        tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀'
        }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀'
        }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀'
        }],
        form: {
            value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        }
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      }
    }
  }
</script>
<style scoped lang="less">
.Maker{
    background: #ffffff;
    height: 100%;
    width: 100%;
    .maker-title{
        height: 5vh;
        line-height: 5vh;
        padding: 0 24px;
        font-size: 18rem;
        font-family: "SourceHanSansCN-Bold";
        font-weight: bold;
        color: #333333;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }
    .content{
        padding:16rem 24rem;
        justify-content: space-between;
        height: calc(100% - 5vh);
        .monitor{
            .h(560);
            width: 100%;
            justify-content: space-between;
            .parameters{
                .w(372);
                height: 100%;
                background: #F1F1F1;
                .title{
                    font-size: 18rem;
                    font-family: "SourceHanSansCN-Bold";
                    font-weight: bold;
                    padding:10rem 17rem;
                }
                .voltage{
                    padding:0 17rem;
                    .panel{
                        justify-content: space-between;
                        margin-top: 20rem;
                        .item{
                            width: 50%;
                        }
                        .name{
                            font-size: 16rem;
                            line-height: 30rem;
                        }
                        p{
                            line-height: 30rem;
                            font-size: 16rem;
                            color: #666666;
                            span{
                                margin-left: 8px
                            }
                        }
                        
                        span{
                            font-size: 18rem;
                            font-weight: bold;
                            color: #0D94FF;
                        }
                    }
                }
            }
            .Smoke{
                .w(372);
                height: 100%;
                background: #F1F1F1;
                .title{
                    font-size: 18rem;
                    font-family: "SourceHanSansCN-Bold";
                    font-weight: bold;
                    padding:10rem 17rem;
                }
                .info{
                    border-top:1px solid rgba(0, 0, 0, 0.15);
                    border-bottom:1px solid rgba(0, 0, 0, 0.15);
                    padding: 10px 0;
                    .item{
                        font-size: 18rem;
                        color: #666666;
                        line-height: 35rem;
                        padding: 0 17rem;
                        span{
                            float: right;
                            color: #0D94FF;
                        }
                    }

                }
            }
            .cabinet{
                .w(380);
                height: 100%;
                background: url("../../assets/img/maker1.png") no-repeat;
                background-size: 100% 100%;
                .title{
                    font-size: 18rem;
                    font-family: "SourceHanSansCN-Bold";
                    font-weight: bold;
                    padding:15rem 22rem 10rem 22rem;
                }
                .surveillance{
                    text-align: center;
                    img{
                        width: 307rem;
                        border:1px dashed #666666;
                    }
                }
                .specs{
                    background: url("../../assets/img/maker3.png") no-repeat;
                    background-size: 100% 100%;
                    .w(330);
                    .h(126);
                    margin:10px auto;
                    justify-content: space-between;
                    padding:0 20rem;
                    .item{
                        line-height: 28rem;
                        max-width: 50%;
                        p{
                            
                        display:-webkit-box;overflow:hidden;text-overflow:ellipsis;word-break:break-all;-webkit-line-clamp:1;-webkit-box-orient:vertical;
                        }
                        .n{
                            display: inline-block;
                            min-width: 55px;
                        }
                        .val{
                            color: #0D94FF;
                            font-weight: bold;
                            font-family: "YouSheBiaoTiHei";
                        }
                    }
                }
            }
        }
        .record{
            .h(314);
            width: 100%;
            background: #F1F1F1;
            .co-option{
                font-size: 18rem;
                font-weight: bold;
                height: 50px;
                line-height: 50px;
                padding: 0 15px;
                .el-date-editor{
                    float: right;
                    border-radius: 50px;
                    height: 35px;
                    line-height: 35px;
                    margin-top: 7px;
                }
                /deep/.el-date-editor .el-range__icon{
                    line-height: 26px;
                }
            }

                /deep/.table{
                    .el-table{
                        background: transparent;
                    }
                    .el-table th, .el-table tr{
                        background: transparent;
                    }
                    .el-table th{
                        background: #E0E5EC;
                        color: #333333;
                        font-size: 16rem;
                        font-weight: 400;
                    }
                    .el-table td, .el-table th{
                        height: 40px;
                        padding:0
                    }
                    .el-table--striped .el-table__body tr.el-table__row--striped td{
                        background: rgba(224, 229, 236, 0.32);
                    }
                }

            .paging{
                text-align: right;
                .el-button{
                    padding: 10px 23px;
                    min-width:100px;
                    background: transparent;
                }
                span{
                    padding: 0 20px;
                    color:#666666;
                    font-size: 16rem;
                }
            }
            
        }
    }
}
</style>